
import { Component, Vue } from 'vue-property-decorator'
import MainMenu from '@/components/layout/MainMenu.vue'

@Component({
  components: {
    MainMenu
  }
})
export default class MainLayout extends Vue {
  get mapLayoutSidebar () {
    return this.$store.state.global.mapLayoutSidebar
  }

  toggleMainMenuSidebar () {
    this.$store.commit('global/toggleMapLayoutSidebar')
  }

  created () {
    if (this.mapLayoutSidebar) {
      this.toggleMainMenuSidebar()
    }
  }
}
